<template>


  <div>

    <v-navigation-drawer
        v-model="session.primary_menu"
        fixed
        app
        width="300"
        class="primary-navigation-drawer"
        @click="session.togglePrimaryMenu()"
        @input="session.togglePrimaryMenu($event)"
    >

      <div class="d-flex flex-column" style="height: 100%;">
        <v-list class="ma-0 pa-0" dense>

          <v-list-item two-line class="pl-3">

            <v-list-item-avatar size="32" tile>
              <v-img :src="require('@/assets/icon.png')"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>PLING</v-list-item-title>
              <v-list-item-subtitle>
              {{ session.server }}
              </v-list-item-subtitle>

            </v-list-item-content>

          </v-list-item>

          <template v-for="(item,index) in menu">

            <v-list-group v-if="item.children && !isDisabled(item)" :key="item.index" :prepend-icon="item.icon">

              <template v-slot:activator>

                <v-list-item-content>

                  <v-list-item-title v-text="item.text"></v-list-item-title>

                </v-list-item-content>

              </template>

              <div v-for="subItem in item.children" :key="subItem.text">

                <v-list-item router :to="subItem.to" v-if="hasLicense(subItem)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.text"></v-list-item-title>

                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.text"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <license-missing-icon :license-key="subItem.requires_license"/>
                  </v-list-item-action>
                </v-list-item>


              </div>

            </v-list-group>
            <v-list-item v-else router :to="item.to" :key="index">

              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>

              <v-list-item-action v-if="!hasLicense(item)">
                <license-missing-icon :license-key="item.requires_license"/>
              </v-list-item-action>


            </v-list-item>

          </template>

        </v-list>

      </div>

    </v-navigation-drawer>

  </div>


</template>


<script>

import { sessionStore } from '@/store/pinia/sessionStore'
import { licenseStore } from '@/store/pinia/licenseStore'
import LicenseMissingIcon from '@/components/plingEditor/infra/licenseMissingIcon.vue'

export default {

  name: 'PrimaryNavigation',
  components: {LicenseMissingIcon},
  setup() {

    const session = sessionStore();
    const license = licenseStore();

    return {
      // you can return the whole store instance to use it in the template
      session,
      license
    }

  },

  computed: {


    menu: function(){

      let self = this;
      let menu = JSON.parse(JSON.stringify(self.items));

      menu = menu.filter(itm => self.isVisible(itm));
      menu.forEach(function (menu_item, index) {

        if (menu_item.children) {

          menu_item.children = menu_item.children.filter(itm => self.isVisible(itm));

          if (menu_item.children.length === 1) {

            menu[index] = menu_item.children[0];

          }

        }

      });
      menu = menu.filter(itm => !itm.children || itm.children.length !== 0);

      return menu;

    }

  },

  data() {
    return {

      server: null,
      items: [
        {icon: 'mdi-view-dashboard', text: this.$t('navigation.primary.dashboard'), to: '/'},
        {icon: 'mdi-account-multiple', text: this.$t('navigation.primary.customers'), to: '/customers', requires_role: 'customer_manager', requires_license: 'crm',},

        { text: this.$t('navigation.primary.order_management'), icon: 'mdi-truck-delivery', requires_role: 'order_manager', requires_license: 'oms',
          children: [
            {text: this.$t('navigation.primary.orders'), to: '/orders/orders', requires_role: 'order_manager'},
            {text: this.$t('navigation.primary.parcels'), to: '/orders/parcels', requires_role: 'order_manager'},
          ]
        },


        { text: this.$t('navigation.primary.coupons'), icon: 'mdi-ticket-percent' , requires_role: 'shop_manager',  requires_license: 'coupons_and_vouchers',

          children: [
            {icon: 'mdi-ticket-percent', text: this.$t('navigation.primary.coupons'), to: '/coupons', requires_role: 'shop_manager'},
            {icon: 'mdi-ticket-percent', text: this.$t('navigation.primary.coupon-conditions'), to: '/coupon-conditions', requires_role: 'shop_manager'},
            {icon: 'mdi-lock-outline', text: this.$t('navigation.primary.coupon-locks'), to: '/coupon-locks', requires_role: 'shop_manager'},
            {icon: 'mdi-ticket-confirmation-outline', text: this.$t('navigation.primary.coupon-redemptions'), to: '/coupon-redemptions', requires_role: 'shop_manager'},

          ]

        },

        { icon: 'mdi-receipt', text: this.$t('navigation.primary.payment_management'), requires_role: 'order_manager', requires_license: 'oms',
          children: [
            {text: this.$t('navigation.primary.invoices'), to: '/invoices', requires_role: 'order_manager'},
            {text: this.$t('navigation.primary.transactions'), to: '/payments', requires_role: 'order_manager'},
            {text: this.$t('navigation.primary.refunds'), to: '/refunds', requires_role: 'order_manager'},
          ]
        },

        {  icon: 'mdi-shopping', text: this.$t('navigation.primary.product_management'),requires_license: 'pim',
            children: [
              {text: this.$t('navigation.primary.products'), to: '/products', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_quality'), to: '/products/quality', requires_role: 'product_manager', requires_license: 'pim-pro'},
              {text: this.$t('navigation.primary.product_manufacturers'), to: '/products/manufacturers', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_brands'), to: '/products/brands', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_categories'), to: '/product-categories', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_attributes'), to: '/product-attributes', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_attribute_sets'), to: '/product-attribute-sets', requires_role: 'product_manager', requires_license: 'pim-pro'},
              {text: this.$t('navigation.primary.product_content_recipes'), to: '/product-content-recipes', requires_role: 'product_manager', requires_license: 'pim-pro'},
              {text: this.$t('navigation.primary.product_tags'), to: '/product-tags', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_media'), to: '/product-media', requires_role: 'product_manager'},
              {
                text: this.$t('navigation.primary.product_looks'),
                to: '/products/looks',
                requires_role: 'product_manager',
                requires_license: 'shop-the-look'
              },
              {text: this.$t('navigation.primary.product_feeds'), to: '/products/feeds', requires_role: 'product_manager'},
              {text: this.$t('navigation.primary.product_discount_presets'), to: '/products/discount-presets', requires_role: 'product_manager', requires_license: 'pim-pro'},
            ]
        },

        { icon: 'mdi-frequently-asked-questions', text: this.$t('navigation.primary.faq'), requires_role: ['product_manager', 'shop_manager'],
          children: [
            {text: this.$t('navigation.primary.faqs'), to: '/faq', requires_role: ['product_manager', 'shop_manager']},
            {text: this.$t('navigation.primary.faq_groups'), to: '/faq/groups', requires_role: ['product_manager', 'shop_manager']},
          ]
        },

        { icon: 'mdi-translate',text: this.$t('navigation.primary.translations'), to: '/translations', requires_role: 'translator', requires_license: 'translation' },
        { icon: 'mdi-store-cog', text: this.$t('navigation.primary.shops'),
          children: [
            {text: this.$t('navigation.primary.shops'), to: '/shops', requires_role: 'shop_manager'},
            {text: this.$t('navigation.primary.shop_groups'), to: '/shop-groups', requires_role: 'shop_manager'},
            {text: this.$t('navigation.primary.price_lists'), to: '/price-lists', requires_role: 'shop_manager'},
            {text: this.$t('navigation.primary.shipping-settings'), to: '/shipping-settings', requires_role: 'shop_manager'},
            { text: this.$t('navigation.primary.payment-methods'), to: '/payment-settings', requires_role: 'shop_manager'},
            {text: this.$t('navigation.primary.tax-manager'), to: '/admin/tax-manager', requires_role: 'admin'},
          ]
        },

        { icon: 'mdi-warehouse', text: this.$t('navigation.primary.warehouses'),
          children: [
            {text: this.$t('navigation.primary.warehouses'), to: '/warehouses', requires_role: 'warehouse_manager'},
            {text: this.$t('navigation.primary.warehouse_reservations'), to: '/warehouses/reservations', requires_role: 'warehouse_manager'},
            {text: this.$t('navigation.primary.warehouse_product_stock'), to: '/warehouses/stock', requires_role: 'warehouse_manager'},
            {text: this.$t('navigation.primary.warehouse_movements'), to: '/warehouses/movements', requires_role: 'warehouse_manager'},
          ]
        },



        {icon: 'mdi-calendar-clock', text: this.$t('navigation.primary.time-tracking'), requires_license: 'worktime_tracking',
          children: [

            {text: this.$t('navigation.primary.time_tracking.calendar'), to: '/time-tracking/calendar', requires_role: 'worktime_tracking_admin'},
            {text: this.$t('navigation.primary.time_tracking.schedule'), to: '/time-tracking/schedule', requires_role: 'worktime_tracking_admin'},
            {text: this.$t('navigation.primary.time_tracking.conditions'), to: '/time-tracking/conditions', requires_role: 'worktime_tracking_admin'},
            {text: this.$t('navigation.primary.time_tracking.sessions'), to: '/time-tracking/sessions', requires_role: 'worktime_tracking_admin'},


          ]
        },
        { icon: 'mdi-cogs', text: this.$t('navigation.primary.administration'),
          children: [

            {text: this.$t('navigation.primary.pling-settings'), to: '/admin/pling-settings', requires_role: 'admin'},
            {icon: 'mdi-sync-circle', text: this.$t('navigation.primary.sync-queue'), to: '/admin/sync-queue', requires_role: 'admin'},
            {icon: 'mdi-account-box-outline', text: this.$t('navigation.primary.users'), to: '/admin/users', requires_role: 'admin'},
            {text: this.$t('navigation.primary.cronjobs'), to: '/admin/cron', requires_role: 'admin'},
            {text: this.$t('navigation.primary.webhooks'), to: '/admin/webhooks', requires_role: 'admin'},
            {text: this.$t('navigation.primary.bank-accounts'), to: '/admin/bank-accounts', requires_role: 'admin'},
            {text: this.$t('navigation.primary.order-attachment-types'), to: '/admin/order-attachment-types', requires_role: 'admin'},

            {text: this.$t('navigation.primary.exports'), to: '/admin/export', requires_role: 'admin'},
            {text: this.$t('navigation.primary.api_log'), to: '/admin/api-log', requires_role: 'admin'},


            {text: this.$t('navigation.primary.communication'), to: '/admin/communication', requires_role: 'admin'},
            {text: this.$t('navigation.primary.files'), to: '/admin/files', requires_role: 'admin'},

            {text: this.$t('navigation.primary.user-authentication-events'), to: '/admin/user-authentication-events', requires_role: 'admin'},
            {text: this.$t('navigation.primary.user-authentication-tokens'), to: '/admin/user-authentication-tokens', requires_role: 'admin'},

          ]
        },
      ],

    }
  },

  methods: {

    isVisible(item){


      let self = this;
      if(typeof item.requires_role === 'undefined'){return true;}


      if(Array.isArray(item.requires_role)){return item.requires_role.some(role => self.session.hasUserRole(role));}

      if(typeof item.requires_role === 'string'){return self.session.hasUserRole(item.requires_role);}


      return self.session.hasUserRole(item.requires_role);



    },

    isDisabled(item){


      if(!this.hasLicense(item)){return true;}

      return false;

    },

    hasLicense: function(item){

      if(typeof item.requires_license === 'undefined'){return true;}
      return this.session.hasModuleLicense(item.requires_license);

    },

  },


}


</script>

